__turbopack_context__.v({
  "card": "aGjTgW_card",
  "cardContent": "aGjTgW_cardContent",
  "postContent": "aGjTgW_postContent",
  "textContent": "aGjTgW_textContent",
  "title": "aGjTgW_title",
});
